import React from 'react';

import Why1 from '../assets/why1.jpg';
import Why2 from '../assets/why2.jpg';
import Why3 from '../assets/why3.jpg';
import Why4 from '../assets/why4.jpg';
import Why5 from '../assets/why5.jpg';
import Why6 from '../assets/why6.jpg';

import { motion } from 'motion/react';

import './why.css';


function Why() {

  const reasons = [
    {
      id: 1,
      number: '01',
      image: Why1,
      title: 'Positioned at the Intersection of AI & Automation',
      paragraphs: [
        'Artificial intelligence is moving beyond experimentation and into everyday business operations.',
        'Nexora is focused on the practical application of AI: automating processes, reducing administrative work, connecting business systems, and helping employees make faster, better-informed decisions.'
      ]
    },
    {
      id: 2,
      number: '02',
      image: Why2,
      title: 'Recurring Revenue Business Model',
      paragraphs: [
        'Nexora is being designed around recurring subscription revenue.',
        'Customers can subscribe to the platform based on company size, functionality, number of connected systems, and usage. This creates opportunities for predictable recurring revenue while allowing customer relationships to expand as platform utilization increases.'
      ]
    },
    {
      id: 3,
      number: '03',
      image: Why3,
      title: 'Large Expansion Opportunity Within Existing Customers',
      paragraphs: [
        "Nexora's initial customer relationship may begin with a single workflow or department.",
        'A customer could initially use Nexora to automate sales administration, for example, and subsequently expand into customer service, finance, human resources, reporting, and internal operations.'
      ]
    },
    {
      id: 4,
      number: '04',
      image: Why4,
      title: 'Designed to Integrate Rather Than Replace',
      paragraphs: [
        'Replacing enterprise software can be expensive, disruptive, and time-consuming.',
        'Nexora takes a different approach.',
        'Our platform is designed to connect with the software businesses already depend on, allowing companies to add intelligent automation without completely rebuilding their technology infrastructure.'
      ]
    },
    {
      id: 5,
      number: '05',
      image: Why5,
      title: 'Multiple Paths to Revenue Expansion',
      paragraphs: [
        "Nexora's initial SaaS subscription represents only one potential source of revenue.",
        'Over time, the company intends to develop additional monetization opportunities through:',
        'Platform subscriptions → AI usage → premium agents → enterprise functionality → integrations → additional departments'
      ]
    },
    {
      id: 6,
      number: '06',
      image: Why6,
      title: 'Built for a Market Undergoing Structural Change',
      paragraphs: [
        'Businesses are increasingly evaluating how AI can improve productivity, reduce operating costs, and enable employees to focus on higher-value activities.',
        'Nexora is being built around this structural transition.',
        "Rather than attempting to predict which individual AI application will dominate, the company's strategy is to provide the infrastructure that allows businesses to continuously adopt and deploy new AI capabilities as the technology evolves."
      ]
    }
  ];


  const gridVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };


  const cardVariants = {
    hidden: (index) => ({
      opacity: 0,
      x: index % 2 === 0 ? -60 : 60,
      y: 30
    }),

    visible: {
      opacity: 1,
      x: 0,
      y: 0,

      transition: {
        duration: 0.7,
        ease: 'easeOut'
      }
    }
  };


  return (

    <motion.section
      id="reasons"
      className="why-section"

      initial={{
        opacity: 0,
        y: 50
      }}

      whileInView={{
        opacity: 1,
        y: 0
      }}

      transition={{
        duration: 0.8,
        ease: 'easeOut'
      }}

      viewport={{
        once: true,
        amount: 0.2
      }}
    >

      {/* Background accents */}

      <div className="why-glow why-glow-left"></div>
      <div className="why-glow why-glow-right"></div>


      <div className="container position-relative">

        {/* SECTION HEADER */}

        <div className="row why-header align-items-end">

          <div className="col-12 col-lg-6">

            <div className="section-label why-label">

              <span className="label-line"></span>

              THE INVESTMENT CASE

            </div>


            <h2 className="why-title">

              Six Compelling

              <span>
                Reasons to Invest
              </span>

            </h2>

          </div>


          <div className="col-12 col-lg-6">

            <div className="why-intro">

              <div className="intro-accent"></div>

              <p>

                The following factors distinguish this offering and reflect
                the structural advantages of investing alongside
                <strong> Nexora Systems.</strong>

              </p>

            </div>

          </div>

        </div>


        {/* REASONS GRID */}

        <motion.div
          className="reasons-grid"

          variants={gridVariants}

          initial="hidden"

          whileInView="visible"

          viewport={{
            once: true,
            amount: 0.1
          }}
        >

          {reasons.map((reason, index) => (

            <motion.article
              className="reason-card"

              key={reason.id}

              custom={index}

              variants={cardVariants}

              whileHover={{
                y: -8
              }}

              transition={{
                duration: 0.3
              }}
            >

              {/* IMAGE */}

              <div className="reason-image-wrapper">

                <img
                  src={reason.image}
                  alt={reason.title}
                  className="reason-image"
                />

                <div className="reason-image-overlay"></div>


                <div className="reason-number">

                  {reason.number}

                </div>

              </div>


              {/* CONTENT */}

              <div className="reason-content">

                <div className="reason-top">

                  {/* <span className="reason-index">
                    INVESTMENT THESIS
                  </span> */}

                  {/* <div className="reason-arrow">
                    →
                  </div> */}

                </div>


                <h4>
                  {reason.title}
                </h4>


                <div className="reason-divider"></div>


                <div className="reason-text">

                  {reason.paragraphs.map((paragraph, index) => (

                    <p key={index}>
                      {paragraph}
                    </p>

                  ))}

                </div>

              </div>

            </motion.article>

          ))}

        </motion.div>

      </div>

    </motion.section>

  );

}


export default Why;